import React, { useEffect, useState } from 'react'
import moment from "moment";

function Att_Helth_Status({ att_date, user_id, daysname, month, year, currendate, holiday_name, inOut_count, start_time, end_time,leave_status }) {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    const [totalHRS, setTotalHRS] = useState(0)

    const gettoken = localStorage.getItem('key');
    // const token_data = jwt_decode(gettoken);
    const newToken = JSON.parse(gettoken);
    const token = newToken.value;

    // if(leave_status === 1){
    //     return <span style={{ display: 'block' }} className="leave"></span>
    // }
    if (inOut_count == 1) {
        var startTime = moment(start_time, 'hh:mm:ss a');
        var endTime = moment(end_time, 'hh:mm:ss a');
        var totalMinutes = endTime.diff(startTime, 'minutes');

        if ((moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sat')) {
            return <span style={{ display: 'block' }} className="weeklyoff"></span>
        } else {
            if (totalMinutes < 240) {
                return <span style={{ display: 'block' }} className="absent"></span>
            }
            if (totalMinutes >= 240 && totalMinutes < 420) {
                return <span style={{ display: 'block' }} className="halfday"></span>

            }
            if (totalMinutes >= 420) {
                return <span style={{ display: 'block' }} className="present"></span>
            }
        }




    }




    if (inOut_count > 1) {
        let token = JSON.parse(localStorage.getItem('key'));
        const response = fetch(SERVER_URL + `api/attendance/day-in-out`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({ att_date: moment(att_date).format("YYYY-MM-DD"), user_id: user_id }),
            }).then(res => res.json())
            .then(data => {
                // console.log('data', data)
                var tmp = 0;
                var total_hrs = 0;
                for (var i = 0; i < data?.data?.length; i++) {
                    const createdDate = moment(data?.data[i].att_date).format('YYYY-MM-DD');
                    const updatedDate = moment(data?.data[i].updated_on).format('YYYY-MM-DD');
                    const timeIn = data?.data[i].start_time
                    const timeOut = data?.data[i].end_time

                    var intime = new Date(createdDate + ' ' + timeIn);
                    var outtime = new Date(updatedDate + ' ' + timeOut);

                    var diffInSeconds = Math.abs(intime - outtime) / 1000;

                    var hours = Math.floor(diffInSeconds / 60 / 60 % 24);
                    var minutes = Math.floor(diffInSeconds / 60 % 60);

                    // var minutes = Math.floor(diffInSeconds / 60 % 60);
                    // var days = Math.floor(diffInSeconds / 60 / 60 / 24);
                    // var hours = Math.floor(diffInSeconds / 60 / 60 % 24);
                    // total_hrs = total_hrs + hours
                    tmp = tmp + minutes
                    total_hrs = total_hrs + hours

                }
                var HRS = total_hrs + Math.floor(tmp / 60)
                var MNTS = tmp % 60
                setTotalHRS((HRS))

            })


        // if (totalHRS >= 4 && totalHRS < 7) {
        //     return <span style={{ display: 'block' }} className="halfday"></span>
        // }
        // if (totalHRS >= 8) {
        //     return <span style={{ display: 'block' }} className="present"></span>
        // }


        if ((moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sat')) {
            return <span style={{ display: 'block' }} className="weeklyoff"></span>
        } else {
            if (totalHRS < 4) {
                return <span style={{ display: 'block' }} className="absent"></span>
            }
            if (totalHRS >= 4 && totalHRS <= 7) {
                return <span style={{ display: 'block' }} className="halfday"></span>

            }
            if (totalHRS >= 8) {
                return <span style={{ display: 'block' }} className="present"></span>
            }
        }

    }
    if ((moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sat')) {
        return <span style={{ display: 'block' }} className="weeklyoff"></span>
    }
    if (holiday_name !== '') {
        return <span style={{ display: 'block' }} className="holiday"></span>
    }
    if (totalHRS < 4 && holiday_name == '' && ((moment(new Date(year, month - 1, daysname)).format("ddd") !== 'Sun') && (moment(new Date(year, month - 1, daysname)).format("ddd") !== 'Sat'))) {

        if (moment().format("D/MM/YYYY") != daysname + '/' + month + '/' + year && inOut_count == null) {
            return <span style={{ display: 'block' }} className="absent"></span>
        }
    }




















    // console.log(att_date)
    // const current_month = moment(new Date()).format("MM");
    // const current_date = moment(new Date()).format("D");
    // useEffect(() => {
    //     if (inOut_count >= 1) {
    //         gethelthofAttendance(att_date, user_id)
    //     }
    // }, [month, year])



    // const gethelthofAttendance = async (att_date, user_id) => {


    //     const attendace_date = moment(att_date).format("YYYY-MM-DD")

    //     await fetch(SERVER_URL + `api/attendance/day-in-out`,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'authorization': `bearer ${token.value}`
    //             },
    //             body: JSON.stringify({
    //                 user_id: user_id,
    //                 att_date: attendace_date,
    //             }),
    //         }).then(res => res.json())
    //         .then(data => {
    //             console.log('data========', data)
    //             // if (data.status == true) {
    //             //     console.log(data.data)
    //             //     var checkCount = 0
    //             //     for (var i = 0; i < data.data.length; i++) {
    //             //         if (data?.data[i]['end_time'] != '00:00:00') {
    //             //             var getstartTime = moment(data?.data[i]['start_time'], 'hh:mm:ss a');
    //             //             var getendTime = moment(data?.data[i]['end_time'], 'hh:mm:ss a');
    //             //             var totalMinutes = getendTime.diff(getstartTime, 'minutes');
    //             //             checkCount = checkCount + totalMinutes
    //             //             setCountTime(checkCount)
    //             //         }
    //             //     }

    //             // }
    //             var total_hrs = 0;
    //             for (var i = 0; i < data?.data?.length; i++) {
    //                 const createdDate = moment(data?.data[i].att_date).format('YYYY-MM-DD');
    //                 const updatedDate = moment(data?.data[i].updated_on).format('YYYY-MM-DD');
    //                 const timeIn = data?.data[i].start_time
    //                 const timeOut = data?.data[i].end_time

    //                 var intime = new Date(createdDate + ' ' + timeIn);
    //                 var outtime = new Date(updatedDate + ' ' + timeOut);

    //                 var diffInSeconds = Math.abs(intime - outtime) / 1000;
    //                 // var days = Math.floor(diffInSeconds / 60 / 60 / 24);
    //                 var hours = Math.floor(diffInSeconds / 60 / 60 % 24);
    //                 total_hrs = total_hrs + hours

    //             }
    //             console.log('==================', total_hrs)
    //             setTotalHRS(total_hrs)


    //             setLife('')






    //             // else if (current_month > month) {
    //             //     setLife(<span style={{ backgroundColor: '#ff3939', display: 'block' }} className="absent"></span>)
    //             // }
    //             // else if (currendate < current_date) {
    //             //     setLife(<span style={{ backgroundColor: '#ff3939', display: 'block' }} className="absent"></span>)
    //             // }
    //             // else if (current_month < month) {
    //             //     setLife(<span style={{ backgroundColor: '#ff3939', display: 'block' }} className="absent"></span>)
    //             // }



    //         })



    // }
    // console.log('totalHRS=======', holiday_name)
    // console.log('totalHRS=======', totalHRS)
    // if (totalHRS >= 8 && holiday_name == undefined) {
    //     return <span style={{ display: 'block' }} className="present"></span>
    // }
    // if (totalHRS >= 4 && totalHRS < 7 && holiday_name == undefined) {
    //     return <span style={{ display: 'block' }} className="halfday"></span>
    // }
    // if ((totalHRS <= 4) && holiday_name == undefined && ((moment(new Date(year, month - 1, daysname)).format("ddd") !== 'Sun') && (moment(new Date(year, month - 1, daysname)).format("ddd") !== 'Sat'))) {
    //     return <span style={{ display: 'block' }} className="absent"></span>
    // }
    // if ((moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sat')) {
    //     // setLife(<span style={{ display: 'block' }} className="weeklyoff"></span>)
    //     return <span style={{ display: 'block' }} className="weeklyoff"></span>
    // }
    // if (holiday_name !== null) {
    //     // console.log('holiday_name=======', holiday_name)
    //     return <span style={{ display: 'block' }} className="holiday"></span>
    // }
    //return life
}

export default Att_Helth_Status
